import Drawer from "notifications/components/drawer";
import { bindActionCreators } from "redux";
import { toggleDrawer, notificationAction } from "notifications/ducks";
import { connect } from "react-redux";
import partial from "lodash/partial";

export function mapStateToProps({ user, notifications }) {
  const userId = user.logged_in ? user.profile_data.id : null;
  const { showDrawer } = notifications;

  return {
    hide: !user.logged_in,
    showDrawer,
    userId,
  };
}

export function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      toggleDrawer,
      markAllAsSeen: partial(notificationAction, "see"),
      clearAll: partial(notificationAction, "clear"),
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Drawer);
